import { TFunction } from 'i18next';
import './product-type-table-header.styles.scss';

interface ProductTypeTableHeaderProps {
  tableHeaderText: string;
  t: TFunction<"materiais", undefined>
}

export default function ProductTypeTableHeader({
  tableHeaderText,
  t
}: ProductTypeTableHeaderProps) {
  return (
    <ul className="product-type-table-header">
      <li style={{ width: '29%' }}>{t('materiais:courseName')}</li>
      <li style={{ width: '12%' }}>{t('materiais:business')}</li>
      <li style={{ width: '12%' }}>{tableHeaderText}</li>
      <li style={{ width: '20%' }}>{t('materiais:availableChapters')}</li>
      <li style={{ width: '15%' }}>{t('materiais:unitType')}</li>
    </ul>
  );
}
